import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationMenuService {
  constructor() {}

  // Event source is responsible for sending 'events' between parent/child components.
  // Events can trigger functions on parent/child. All events require a name. Data is optional.
  private eventSource = new Subject<any>();

  listenForEvent<Type>(): Observable<{ eventName: string; data?: Type }> {
    return this.eventSource.asObservable();
  }

  sendEvent<Type>(eventName: string, data?: Type) {
    this.eventSource.next({ eventName, data });
  }
}
